import { Bill, Billable, BillablesServiceResponse, BillingInfoServiceResponse, BillItem, BillServiceResponse, BillUpdateResponse, DocumentType, CreatePaymentRequest, InsuranceBill, InsuranceBillsResponse, InsuranceBillResponse, ClaimsResponse, TaxRate } from "../pages/hospital/Billing/types";
import axios from "../utils/axios";

export function createBillService(uuidInstitution: string, uuidPatient: string, bill: Bill): Promise<BillServiceResponse> {
    return new Promise((resolve, reject) => {
        axios
            .post(import.meta.env.VITE_APP_API_URL + "/billing/investigation/" + uuidInstitution + "/bill/" + uuidPatient, bill, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function updateBillService(uuidInvestigation: string, uuidBill: string, bill: Bill): Promise<{ status: number }> {
    return new Promise((resolve, reject) => {
        axios
            .put(import.meta.env.VITE_APP_API_URL + "/billing/investigation/" + uuidInvestigation + "/bill/" + uuidBill, bill, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function updateBillItemsStatusService(uuidInvestigation: string, uuidBill: string, bill: Bill, paymentRecord?: CreatePaymentRequest): Promise<BillUpdateResponse> {
    return new Promise((resolve, reject) => {
        // Construct request body according to new API format
        const requestBody: any = {
            billItems: bill.billItems
        };
        
        // Add payment information if payment record is provided
        if (paymentRecord && paymentRecord.amount >= 0) {
            requestBody.payment = {
                amount: paymentRecord.amount,
                paymentMethodInvestigationId: paymentRecord.paymentMethodInvestigationId,
                paymentData: paymentRecord.paymentData || null
            };
        }
        
        axios
            .patch(import.meta.env.VITE_APP_API_URL + "/billing/investigation/" + uuidInvestigation + "/bill/" + uuidBill + "/update", requestBody, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function createUpdateBillingInfoService(uuidInvestigation: string, billingInfo: any):Promise<BillingInfoServiceResponse> {
    return new Promise((resolve, reject) => {
        axios
            .put(import.meta.env.VITE_APP_API_URL + "/billing/investigation/" + uuidInvestigation + "/billingInfo", billingInfo, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function updateBillablesService(uuidInvestigation: string, idBillingInfo:number, billables: BillItem[]):Promise<BillablesServiceResponse> {
    return new Promise((resolve, reject) => {
        axios
            .put(import.meta.env.VITE_APP_API_URL + "/billing/investigation/" + uuidInvestigation + "/billables/"+idBillingInfo, billables, 
                { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getDocumentsService(uuidInvestigation: string): Promise<{ status: number, bills: Bill[] }> {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/billing/investigation/" + uuidInvestigation + "/documents", { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getBillsPatientService(uuidInvestigation: string, uuidPatient:string): Promise<{ status: number, bills: Bill[] }> {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/billing/investigation/" + uuidInvestigation + "/bills/patient/"+uuidPatient, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}



export function getBillablesByCoverageService(uuidInvestigation: string, idBillingInfo: number, idCoverage:number): Promise<BillablesServiceResponse> {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/billing/investigation/" + uuidInvestigation + "/billables/" + idBillingInfo + "/coverage/"+idCoverage, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getBillablesService(uuidInvestigation: string, idBillingInfo: number, idInsurance:number): Promise<BillablesServiceResponse> {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/billing/investigation/" + uuidInvestigation + "/billables/" + idBillingInfo + "/insurance/"+idInsurance, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getBillableComboService(uuidInvestigation: string, idBillingInfo: number): Promise<BillablesServiceResponse> {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/billing/investigation/" + uuidInvestigation + "/billablecombo/" + idBillingInfo, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function updateDocumentType(uuidInvestigation: string, uuidBill: string, type:DocumentType): Promise<BillServiceResponse> {
    return new Promise((resolve, reject) => {
        axios
            .put(`${import.meta.env.VITE_APP_API_URL}/billing/investigation/${uuidInvestigation}/bill/${uuidBill}/change/${type}`, {}, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getBillByUuidService(uuidInvestigation: string, uuidBill: string): Promise<{ status: number, bill: Bill }> {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/billing/investigation/" + uuidInvestigation + "/bill/" + uuidBill, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

/**
 * Updates the patient's coverage for a bill
 * @param uuidInvestigation - Investigation UUID
 * @param uuidBill - Bill UUID
 * @param newCoverageId - New coverage ID to assign to the patient
 * @returns Promise with status and updated bill
 */
export function updateBillCoverageService(uuidInvestigation: string, uuidBill: string, newCoverageId: number): Promise<{ status: number, bill: Bill }> {
    return new Promise((resolve, reject) => {
        axios
            .put(
                import.meta.env.VITE_APP_API_URL + "/billing/investigation/" + uuidInvestigation + "/bill/" + uuidBill + "/coverage",
                { newCoverageId },
                { headers: { "Authorization": localStorage.getItem("jwt") } }
            )
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function refreshBillPricesService(uuidInvestigation: string, uuidBill: string): Promise<{ status: number, bill: Bill, updatedItems: { billItemId: number, oldAmount: number, newAmount: number }[] }> {
    return new Promise((resolve, reject) => {
        axios
            .put(
                import.meta.env.VITE_APP_API_URL + "/billing/investigation/" + uuidInvestigation + "/bill/" + uuidBill + "/refresh-prices",
                {},
                { headers: { "Authorization": localStorage.getItem("jwt") } }
            )
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

// Insurance Bills Services
export function getInsuranceBillsService(
    uuidInvestigation: string,
    filters?: {
        organizationId?: number;
        periodStart?: Date;
        periodEnd?: Date;
        status?: number;
    }
): Promise<InsuranceBillsResponse> {
    return new Promise((resolve, reject) => {
        const params = new URLSearchParams();
        
        if (filters?.organizationId) {
            params.append('organizationId', filters.organizationId.toString());
        }
        if (filters?.periodStart) {
            params.append('periodStart', filters.periodStart.toISOString().split('T')[0]);
        }
        if (filters?.periodEnd) {
            params.append('periodEnd', filters.periodEnd.toISOString().split('T')[0]);
        }
        if (filters?.status !== undefined) {
            params.append('status', filters.status.toString());
        }
        
        const queryString = params.toString();
        const url = `/billing/investigation/${uuidInvestigation}/insurance-bills${queryString ? `?${queryString}` : ''}`;
        
        axios
            .get(import.meta.env.VITE_APP_API_URL + url, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getInsuranceBillByUuidService(
    uuidInvestigation: string,
    billUuid: string
): Promise<InsuranceBillResponse> {
    return new Promise((resolve, reject) => {
        axios
            .get(
                import.meta.env.VITE_APP_API_URL + `/billing/investigation/${uuidInvestigation}/insurance-bills/${billUuid}`,
                { headers: { "Authorization": localStorage.getItem("jwt") } }
            )
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getClaimsForInsuranceBillService(
    uuidInvestigation: string,
    billUuid: string
): Promise<ClaimsResponse> {
    return new Promise((resolve, reject) => {
        axios
            .get(
                import.meta.env.VITE_APP_API_URL + `/billing/investigation/${uuidInvestigation}/insurance-bills/${billUuid}/claims`,
                { headers: { "Authorization": localStorage.getItem("jwt") } }
            )
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function closeInsuranceBillService(
    uuidInvestigation: string,
    billUuid: string
): Promise<BillUpdateResponse> {
    return new Promise((resolve, reject) => {
        axios
            .put(
                import.meta.env.VITE_APP_API_URL + `/billing/investigation/${uuidInvestigation}/bill/${billUuid}/close`,
                {},
                { headers: { "Authorization": localStorage.getItem("jwt") } }
            )
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

/**
 * Export billables as CSV
 * @param uuidInvestigation - Investigation UUID
 * @param idBillingInfo - BillingInfo ID
 * @returns Promise with CSV content as string
 */
export function exportBillablesCSVService(
    uuidInvestigation: string, 
    idBillingInfo: number
): Promise<{ status: number, csv: string }> {
    return new Promise((resolve, reject) => {
        axios
            .get(
                `${import.meta.env.VITE_APP_API_URL}/billing/investigation/${uuidInvestigation}/billables/${idBillingInfo}/export/csv`,
                { 
                    headers: { "Authorization": localStorage.getItem("jwt") },
                    responseType: 'text'
                }
            )
            .then((response) => {
                if (response.status === 200) {
                    resolve({ status: 200, csv: response.data });
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

/**
 * Import billables from CSV
 * @param uuidInvestigation - Investigation UUID
 * @param idBillingInfo - BillingInfo ID
 * @param csvContent - CSV content as string
 * @param forceCreateInsurance - Auto-create missing insurances
 * @param forceCoveragePercent - Force coverage percentage
 * @returns Promise with import result
 */
export async function importBillablesCSVService(
    uuidInvestigation: string, 
    idBillingInfo: number,
    csvContent: string,
    forceCreateInsurance: boolean,
    forceCoveragePercent: boolean
): Promise<{ status: number, jobId?: string, message: string }> {
    try {
        const response = await axios.post(
            `${import.meta.env.VITE_APP_API_URL}/billing/investigation/${uuidInvestigation}/${idBillingInfo}/csv/billables/simplified/forceCreateInsurance/${forceCreateInsurance}/forceCoveragePercent/${forceCoveragePercent}`,
            csvContent,
            { 
                headers: { 
                    "Authorization": localStorage.getItem("jwt"),
                    "Content-Type": "text/plain"
                },
                validateStatus: (status) => status >= 200 && status < 300
            }
        );
        
        return { 
            status: response.status, 
            jobId: response.data.jobId,
            message: response.data.message || "Import successful" 
        };
    } catch (error: any) {
        // Re-throw to let component handle the error
        throw error;
    }
}

/**
 * Get CSV import job status
 * @param uuidInvestigation - Investigation UUID
 * @param jobId - Job ID from import response
 * @returns Promise with job status
 */
export async function getCSVImportJobStatus(
    uuidInvestigation: string,
    jobId: string
): Promise<{
    state: 'pending' | 'processing' | 'completed' | 'failed';
    progress?: number;
    message?: string;
    result?: any;
    error?: string;
}> {
    try {
        const response = await axios.get(
            `${import.meta.env.VITE_APP_API_URL}/billing/investigation/${uuidInvestigation}/csv-import/job/${jobId}/billables`,
            { 
                headers: { 
                    "Authorization": localStorage.getItem("jwt")
                }
            }
        );
        
        return response.data;
    } catch (error: any) {
        throw error;
    }
}

/**
 * Export billable combos as CSV
 * @param uuidInvestigation - Investigation UUID
 * @param idBillingInfo - BillingInfo ID
 * @returns Promise with CSV content as string
 */
export function exportBillableCombosCSVService(
    uuidInvestigation: string, 
    idBillingInfo: number
): Promise<{ status: number, csv: string }> {
    return new Promise((resolve, reject) => {
        axios
            .get(
                `${import.meta.env.VITE_APP_API_URL}/billing/investigation/${uuidInvestigation}/${idBillingInfo}/csv/combos`,
                { 
                    headers: { "Authorization": localStorage.getItem("jwt") },
                    responseType: 'text'
                }
            )
            .then((response) => {
                if (response.status === 200) {
                    resolve({ status: 200, csv: response.data });
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

/**
 * Import billable combos from CSV
 * @param uuidInvestigation - Investigation UUID
 * @param idBillingInfo - BillingInfo ID
 * @param csvContent - CSV content as string
 * @returns Promise with import result
 */
export async function importBillableCombosCSVService(
    uuidInvestigation: string, 
    idBillingInfo: number,
    csvContent: string
): Promise<{ status: number, message: string }> {
    try {
        const response = await axios.post(
            `${import.meta.env.VITE_APP_API_URL}/billing/investigation/${uuidInvestigation}/${idBillingInfo}/csv/combos`,
            csvContent,
            { 
                headers: { 
                    "Authorization": localStorage.getItem("jwt"),
                    "Content-Type": "text/plain"
                },
                validateStatus: (status) => status >= 200 && status < 300
            }
        );
        
        return {
            status: response.status,
            message: response.data.message || "Import successful"
        };
    } catch (error: any) {
        throw error;
    }
}

// Tax Rate Services
export function getTaxRatesService(uuidInvestigation: string): Promise<{ status: number, taxRates: TaxRate[] }> {
    return new Promise((resolve, reject) => {
        axios
            .get(`${import.meta.env.VITE_APP_API_URL}/billing/investigation/${uuidInvestigation}/tax-rates`, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function createTaxRateService(uuidInvestigation: string, taxRate: TaxRate): Promise<{ status: number, taxRate: TaxRate }> {
    return new Promise((resolve, reject) => {
        axios
            .post(`${import.meta.env.VITE_APP_API_URL}/billing/investigation/${uuidInvestigation}/tax-rate`, taxRate, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function updateTaxRateService(uuidInvestigation: string, uuidTaxRate: string, taxRate: Partial<TaxRate>): Promise<{ status: number, taxRate: TaxRate }> {
    return new Promise((resolve, reject) => {
        axios
            .put(`${import.meta.env.VITE_APP_API_URL}/billing/investigation/${uuidInvestigation}/tax-rate/${uuidTaxRate}`, taxRate, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function deleteTaxRateService(uuidInvestigation: string, uuidTaxRate: string): Promise<{ status: number }> {
    return new Promise((resolve, reject) => {
        axios
            .delete(`${import.meta.env.VITE_APP_API_URL}/billing/investigation/${uuidInvestigation}/tax-rate/${uuidTaxRate}`, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}